import React, { useState, useRef } from 'react';
import { useLegalLinkEvents } from '../../../hooks';
import { LegalButton, LegalModal } from '../../Common';
import { ModalContextProvider } from '../../../context/ModalContext';
import { LegalTextPropTypes } from './props';

/**
 * Legal text component with interactive modal support
 * Renders legal text with clickable links that open detailed modal content
 * Manages modal state and link event handling automatically
 *
 * @param {Object} props - Component props
 * @param {Object} props.text - Text object containing legal content and modal keys
 * @returns {JSX.Element} Legal button with conditional modal
 */
function LegalText({ text }) {
  const [legalTmntKey, setLegalTmntKey] = useState(null);
  const legalLinkRef = useRef([]);
  const legalTextIndexRef = useRef(0);

  useLegalLinkEvents(legalLinkRef, (value) => {
    if (value) setLegalTmntKey(value);
  });

  const index = legalTextIndexRef.current;
  // eslint-disable-next-line no-param-reassign
  legalTextIndexRef.current += 1;

  return (
    <>
      <LegalButton
        text={text}
        ref={(el) => {
          // eslint-disable-next-line no-param-reassign
          if (el) legalLinkRef.current[index] = el;
        }}
      />
      {
        legalTmntKey && (
          <ModalContextProvider>
            <LegalModal legalText={legalTmntKey} onClose={() => setLegalTmntKey(null)} />
          </ModalContextProvider>
        )
      }
    </>
  );
}

LegalText.propTypes = LegalTextPropTypes;

export default LegalText;
